/* eslint-disable no-plusplus */
/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */

import React from 'react';
import { PieChart } from 'react-chartkick';
import { connect } from 'react-redux';

import CurrencySign from 'components/price/CurrencySign.component';
import { useTranslation } from 'providers/GILT.provider';
import { selectCurrentSalonCurrency } from 'selectors/currentSalon.selectors';
import currencySign from 'utils/intl/currencySign.util';

import Container from 'reports/DashboardReports/Charts/common/Container';
import LegendContainer from 'reports/DashboardReports/Charts/common/LegendContainer';
import { convertToMoneyAfterVat } from 'reports/utils';

import 'chartjs-plugin-style';

function generateColors(length) {
  const opacityJump = 1 / length;
  let currentOpacity = 1;
  const colors = [];
  for (let i = 0; i < length; i++) {
    colors.push(`rgba(127, 0, 180, ${currentOpacity})`);
    currentOpacity -= opacityJump;
  }

  return colors;
}

function generateLegend(data) {
  const items = [];
  let sum = 0;
  Object.keys(data).forEach((key) => {
    sum += convertToMoneyAfterVat(parseFloat(data[key]));
  });
  Object.keys(data).forEach((key) => {
    items.push({
      text: key,
      val: (
        <>
          <CurrencySign />
          {convertToMoneyAfterVat(parseFloat(data[key]))} ({((parseFloat(data[key]) / sum) * 100).toFixed(2)}%)
        </>
      ),
    });
  });

  return items;
}

const SalesByCategoryPieChart = ({ data, currentSign }) => {
  const { t } = useTranslation();

  const libSettings = {
    tooltips: {
      enabled: true,
      backgroundColor: '#192340',
      titleFontSize: 15,
      titleFontStyle: '900',
      titleFontFamily: 'ProximaNova-b',
      titleFontColor: 'white',
      caretSize: 7,
      yPadding: 12,
      xPadding: 14,
      bodyFontSize: 16,
      borderColor: '#192340',
      shadowOffsetX: 3,
      shadowOffsetY: 3,
      shadowBlur: 10,
      shadowColor: 'rgba(0, 0, 0, 0.5)',
      callbacks: {
        label(tooltipItem, data) {
          const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
          const label = data.labels[tooltipItem.index];
          const currency = currencySign({
            value,
            currentSalonAbbr: currentSign,
          });
          return `${label}: ${currency}`;
        },
      },
    },
  };

  const chartDataset = {
    borderWidth: 0,
    hoverBorderColor: 'white',
    hoverBorderWidth: 2,
  };

  return (
    <Container chartName={t('businessReports.weekly.salesChartTitle')} additionalClass="pie">
      <LegendContainer items={generateLegend(data)} prefix="" additionalClass="displayDot" />
      <PieChart legend={false} download data={data} colors={generateColors(Object.keys(data).length)} dataset={chartDataset} library={libSettings} />
    </Container>
  );
};

const mapStateToProps = (state) => ({
  currentSign: selectCurrentSalonCurrency(state),
});

const SalesByCategoryPieChartHoc = connect(mapStateToProps)(SalesByCategoryPieChart);

export default SalesByCategoryPieChartHoc;
